var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedBlur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 171,
    viewBox: "0 0 304 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28,
    filter: "url(#filter0_f_217_2496)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 151.8,
    cy: 151.8,
    r: 133.5,
    fill: "url(#paint0_linear_217_2496)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_217_2496",
    x: -0.00019455,
    y: 0.0000495911,
    width: 303.6,
    height: 303.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.15,
    result: "effect1_foregroundBlur_217_2496"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_2496",
    x1: 152.3,
    y1: 186.8,
    x2: 152.3,
    y2: 9.30005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7000B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7000B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBlur);
export default __webpack_public_path__ + "static/media/red_blur.ee922670120e91db9f4b9629b4291aef.svg";
export { ForwardRef as ReactComponent };